import { render, staticRenderFns } from "./GalleryCardMenu.vue?vue&type=template&id=2fd6c7e4&scoped=true"
var script = {}
import style0 from "./GalleryCardMenu.vue?vue&type=style&index=0&id=2fd6c7e4&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd6c7e4",
  null
  
)

export default component.exports